/**
 * **NOTE** The styles in this file are a direct copy of the styles found at:
 * `src/modules/templateEditor/EditSMS/`.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does not fetch its data from grapqhl, a necessity for the templateEdit preview.
 */

import styled from 'styled-components';
import { colors, fonts, letterSpacing, subtleShadow } from 'ui/theme';

export const ContentPreviewContainer = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
`;

export const DevicePreview = styled.div`
    align-items: center;
    display: flex;
    background-color: ${colors.white};
    border-color: transparent;
    border-radius: 20px;
    flex-direction: column;
    height: 534px;
    letter-spacing: ${letterSpacing.pos10};
    margin: auto;
    overflow: hidden;
    width: 286px;
    ${subtleShadow}
    &[data-platform='apple'] {        
        font-family: ${fonts.sfPro};
    }
    &[data-platform='android'] {
        font-family: ${fonts.roboto};
    }
`;
